export default __webpack_public_path__ + "static/media/monitor-youth.8fcf92a2.png";